import React, { useEffect, useState, useCallback } from "react";

import IngestionApi from "apis/ingestion";
import { PageLoader } from "clearsense-ui/components";
import { EmptyState } from "components/Common";
import { humanize } from "utils/stringManipulations";

import ActionHeader from "./ActionHeader";
import { INITIAL_DATASETS } from "./constants";
import DatasetsHome from "./Home";
import PrimaryHeader from "./PrimaryHeader";

const Datasets = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [filterConditions, setFilterConditions] = useState([]);
  const [isTableView, setIsTableView] = useState(false);
  const [datasets, setDatasets] = useState(INITIAL_DATASETS);

  const fetchDatasets = useCallback(async () => {
    setIsLoading(true);
    try {
      const { data } = await IngestionApi.fetchDatasets();
      const datasetData = [...INITIAL_DATASETS, ...handleDatasetsList(data)];
      setDatasets(datasetData);
    } catch (error) {
      logger.error(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => fetchDatasets(), []);

  const handleDatasetsList = datasets =>
    datasets.map(({ datasetName }, index) => {
      const currentDatasetName = datasetName.substring(
        datasetName.lastIndexOf("/") + 1
      );
      const datasetNameHumanized = humanize(currentDatasetName);

      return {
        id: index,
        filename: datasetNameHumanized || `Dataset ${index + 1}`,
        rowCount: 614,
        columnCount: 13,
        isLocal: true,
        link: `../data-science/quality-analysis/${currentDatasetName}/approachable-ai`,
      };
    });

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <div className="cs-ui-container cs-ui-container__table">
      <PrimaryHeader />
      <ActionHeader
        filterConditions={filterConditions}
        setFilterConditions={setFilterConditions}
        totalCount={datasets?.length ?? 0}
        isTableView={isTableView}
        setIsTableView={setIsTableView}
      />
      {datasets?.length ? (
        <DatasetsHome
          datasets={datasets}
          isTableView={isTableView}
          isLoading={isLoading}
        />
      ) : (
        <EmptyState mainText="No Datasets Found" />
      )}
    </div>
  );
};

export default Datasets;
